const responseStatus = {
  ok: 200,
  created: 201,
  accepted: 202,
  noContent: 204,
  resetContent: 205,
  partialContent: 206,
  multipleChoices: 300,
  movedPermanently: 301,
  found: 302,
  seeOther: 303,
  notModified: 304,
  useProxy: 305,
  temporaryRedirect: 307,
  permanentRedirect: 308,
  tooManyRequests: 429,
  unauthorized: 401,
  forbidden: 403,
  payloadTooLarge: 413
};

export default responseStatus;
